module.exports = __webpack_public_path__ + "img/logo-WC-microsite-2.de5f653d.svg";